import React from 'react';

import { Button } from 'common/components/Button';
import Icon from 'common/components/Icon';
import { useLocalization } from 'common/providers/LocaleProvider';
import { captureException } from 'common/utils/error-reporter';
import { TrackingInteraction, trackReferAFriendClick } from './tracking';

const ICON_SIZE = 24;

const ShareButton = ({ referralLink, isDisabled }) => {
  const { t } = useLocalization();

  const handleShareClick = async () => {
    const shareData = {
      text: `${t('h24_refer_share_message')} ${referralLink}`,
    };
    if (navigator.canShare?.(shareData)) {
      try {
        trackReferAFriendClick(
          t('h24_refer_share_btn_label'),
          TrackingInteraction.ShareReferralLink
        );

        await navigator.share(shareData);
      } catch (error) {
        captureException(error);
      }
    }
  };

  return (
    <Button onClick={handleShareClick} disabled={isDisabled} themeWidth={['100%', 'fit-content']}>
      <Icon name="share" fill="sys.neutral.icon.inverted" size={ICON_SIZE} />
      {t('h24_refer_share_btn_label')}
    </Button>
  );
};

export default ShareButton;
